import { Numeric2Icon } from './Numeric2Icon';

/**
 * author: GreenTurtwig
 * id 55F915B1-69CB-4394-9313-F8A0B7A8EBB9
 * name numeric-2
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-2.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number2Icon = Numeric2Icon;
export default Number2Icon